import { render, staticRenderFns } from "./NewMessagesBadge.vue?vue&type=template&id=69288a68&scoped=true"
import script from "./NewMessagesBadge.vue?vue&type=script&lang=ts"
export * from "./NewMessagesBadge.vue?vue&type=script&lang=ts"
import style0 from "./NewMessagesBadge.vue?vue&type=style&index=0&id=69288a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69288a68",
  null
  
)

export default component.exports